import LandingHeader from './LandingHeader.jsx';
import Hero from './Hero.jsx';
import Hazards from './Hazards.jsx';
import HowItWorks from './HowItWorks.jsx';
import Audiences from './Audiences.jsx';
import EarlyAccess from './EarlyAccess.jsx';
import Tiers from './Tiers.jsx';
import FinalCTA from './FinalCTA.jsx';
import LandingFooter from './LandingFooter.jsx';

export default function Landing({ betaMode, themeMode, onThemeChange, onOpenAuth }) {
  return <div className="landing-page"><LandingHeader betaMode={betaMode} themeMode={themeMode} onThemeChange={onThemeChange} onOpenAuth={onOpenAuth} /><main><Hero betaMode={betaMode} onOpenAuth={onOpenAuth} /><Hazards /><HowItWorks /><Audiences />{betaMode && <EarlyAccess onOpenAuth={onOpenAuth} />}<Tiers betaMode={betaMode} /><FinalCTA betaMode={betaMode} onOpenAuth={onOpenAuth} /></main><LandingFooter betaMode={betaMode} /></div>;
}
